import { useIntl } from 'react-intl';
import getTrailFeatureLabel from '@alltrails/trails/utils/getTrailFeatureLabel';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import getFeatureIcon from '../../utils/getFeatureIcon';
import { features } from '../../utils/getValidFeatures';
import useChipsFilterConfig from './useChipsFilterConfig';

const useFeatureChipsConfig = (exploreServiceFilters: ExploreServiceFilters, onFiltersChange: (updatedFilters: ExploreServiceFilters) => void) => {
  const intl = useIntl();

  return useChipsFilterConfig({
    exploreServiceFilterKey: 'feature',
    exploreServiceFilters,
    getValueIcon: getFeatureIcon,
    getValueLabel: feature => getTrailFeatureLabel(intl, feature),
    label: intl.formatMessage({ defaultMessage: 'Features' }),
    onFiltersChange,
    values: features
  });
};

export default useFeatureChipsConfig;
